/**
 * 检测当前运行的浏览器
 */
export const detectBrowser = (): 'firefox' | 'chrome' | 'edge' | 'other' => {
  const userAgent = navigator.userAgent.toLowerCase();
  
  // Edge浏览器检测 (基于Chromium的Edge包含'edg'字符串)
  if (userAgent.includes('edg') || userAgent.includes('edge')) {
    return 'edge';
  } else if (userAgent.includes('firefox')) {
    return 'firefox';
  } else if (userAgent.includes('chrome') || userAgent.includes('chromium')) {
    return 'chrome';
  } else {
    return 'other';
  }
};

/**
 * 检查当前是否在扩展环境中运行
 */
export const isExtensionContext = (): boolean => {
  return typeof chrome !== 'undefined' && 
    (!!chrome.extension || !!chrome.runtime);
};

/**
 * 获取运行环境信息
 */
export const getRuntimeInfo = () => {
  return {
    browser: detectBrowser(),
    isExtension: isExtensionContext(),
    userAgent: navigator.userAgent
  };
}; 